import { render, staticRenderFns } from "./Testimonial.vue?vue&type=template&id=194e7b3c&scoped=true&"
import script from "./Testimonial.vue?vue&type=script&lang=js&"
export * from "./Testimonial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "194e7b3c",
  null
  
)

export default component.exports